export default __webpack_public_path__ + "static/media/D1907_03_25_Silla.2e8e60c6.jpg";